<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body m-0">
                        <button v-if="defaultLocation==null" class="btn btn-infbtn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="getCurrentPosition">
                            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
                            موقعیت فعلی
                        </button>
                        <button v-if="defaultLocation!=null" @click="openInGoogleMap" class="btn btn-infbtn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100">
                            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
                            نمایش در نقشه
                        </button>

                        <slot name="body">
                            <div class="mb-4">
                                <l-map ref="mymap"  @click="onMapClick"  style="height:300px" :zoom="16" :center="mapLocationObject" v-if="mapLocationObject!=null">
                                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                                    <l-marker :lat-lng="mapLocationObject"></l-marker>
                                </l-map>

                            </div>
                        </slot>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">
                            <button v-if="readOnly==false && defaultLocation==null" class="btn btn-xxs rounded-s bg-green2-light" @click="SaveLocation">
                                <i class="fa fa-check ml-2"></i>
                                ثبت
                            </button>
                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>
 import {ref,onMounted} from 'vue';
   import "leaflet/dist/leaflet.css"
    import { LMap,LMarker,LTileLayer } from "@vue-leaflet/vue-leaflet";
    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    import { Icon } from 'leaflet';
    import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch'
    // import LGeosearch from "vue2-leaflet-geosearch";
    import "leaflet-geosearch/dist/geosearch.css";
  

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });


    export default {
        setup(){
            const mymap = ref(null);
            onMounted(() => {
                //map.value.mapObject.on("geosearch/showlocation", this.onSearch);
                 console.log("mymap:");
            console.log(mymap.value);
            });
            return{
                mymap
            }
        },
        components: {
            LMap,
            LMarker,
            LTileLayer
        },
        props: ['defaultLocation', 'defaultAddress','attId'],
        data() {
            return {
                mapLocationObject: null,
                mapLocation:null,
                position:null,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                Loading: false,
                errorMsg: null,
                readOnly:false,
                address:null,
                geoSearchOptions: {
                provider: new OpenStreetMapProvider(),
                showMarker: false,
                autoClose: true
                },
            };
        },
       
        async created(){
            
            if(this.defaultLocation==null)
            {
                await this.getCurrentPosition();
                document.addEventListener("deviceready", () => {
                this.checkLocation();
            });
                
            }
            else{
                var m=this.defaultLocation.split(',');
                this.mapLocation = this.defaultLocation;
                this.mapLocationObject = latLng(m[0], m[1]);
            }
           
        },
       
       
        watch: {
    mapLocationObject: {
      deep: true,
      async handler(value) {
        this.address = await this.getAddress();
        console.log(this.address);
      }
    }
  },
   
        methods: {
            async onMapClick(v) {
				if (!(window.location.href.includes("UserPresence") || window.location.href.includes("CreateUserPresence") || window.location.href.includes("EditUserPresence") || window.location.href.includes("ShowUsersOnMap"))) {
					if (v.latlng && this.defaultLocation == null) {
						this.mapLocationObject = v.latlng;
						this.mapLocation = v.latlng.lat + ',' + v.latlng.lng;
						console.log(v.latlng);
					}
                }

            },
             async getAddress() {
      //this.loading = true;
      let address = "Unresolved address";
      try {
        const { lat, lng } = this.mapLocationObject;
        const result = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa-IR`
        );
        if (result.status === 200) {
          const body = await result.json();
          address = body.display_name;
        }
      } catch (e) {
        console.error("Reverse Geocode Error->", e);
      }
      //this.loading = false;
      return address;
    },
            async getCurrentPosition() {
                try {
                    const coordinates = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: true
                    });
                    console.log(coordinates.coords.latitude);
                    this.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
                }
                catch (ex) {
                    console.log(ex);
                    this.showErrorMessage("خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید.");
                
                 this.$emit('close');
                }
                 
            },
             onSearch(value) {
                const loc = value.location;
                this.mapLocationObject = { lat: loc.y, lng: loc.x };
            },
            checkLocation() {
                window.plugins.locationAccuracy.canRequest(function (canRequest) {
                    if (canRequest) {
                        window.plugins.locationAccuracy.request(function (success) {
                            console.log("Successfully requested accuracy: " + success.message);
                        }, function (error) {
                            console.error("Accuracy request failed: error code=" + error.code + "; error message=" + error.message);
                            if (error.code !== window.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                                if (window.confirm("Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?")) {
                                    window.plugins.diagnostic.switchToLocationSettings();
                                }
                            }
                        }, window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                    } else {
                        // request location permission and try again
                    }
                });
            },
            SaveLocation() {
                var att={attDescription:this.address,fileName:this.mapLocation,attTitle:"location"};
                 this.$emit('saveLocation',att);
            },
            openInGoogleMap(){
    // If it's an iPhone..
    if( (navigator.platform.indexOf("iPhone") != -1) 
        || (navigator.platform.indexOf("iPod") != -1)
        || (navigator.platform.indexOf("iPad") != -1))
         window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination="+this.mapLocation);
    else
         window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination="+this.mapLocation);
}
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
